import script from "./Accounts.vue?vue&type=script&setup=true&lang=js"
export * from "./Accounts.vue?vue&type=script&setup=true&lang=js"

import "./Accounts.vue?vue&type=style&index=0&id=77a4db09&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a4db09"]])

export default __exports__